export function EmptyState({ title, text, action, testId }) {
    return (
        <div
            data-testid={testId}
            className="flex flex-col items-start gap-4 rounded-lg border border-line bg-card px-6 py-16 text-left"
        >
            <div className="relative h-14 w-14">
                <span className="absolute inset-0 rounded-lg bg-terracotta/10" />
                <span className="absolute left-3 top-3 h-8 w-8 rounded-md border border-terracotta/40" />
                <span className="absolute left-5 top-5 h-8 w-8 rounded-md bg-terracotta/25" />
            </div>
            <h3 className="text-[20px] font-bold tracking-tight text-ink">{title}</h3>
            <p className="measure text-[16px] leading-[1.6] text-subtle">{text}</p>
            {action}
        </div>
    );
}
